import { render, staticRenderFns } from "./MessageContentSticker.vue?vue&type=template&id=6d06eb9b&scoped=true"
import script from "./MessageContentSticker.vue?vue&type=script&lang=js"
export * from "./MessageContentSticker.vue?vue&type=script&lang=js"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=6d06eb9b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06eb9b",
  null
  
)

export default component.exports